export default {
  collaborations: {
    total: 0,
    users: [],
    isLoading: false
  }
}
